<template>
  <div class="wrapper">
    <Validation-Observer
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="login()"
    >
      <div class="flex justify-center mb-6">
        <div class="w-1/4 bg-gray-100 bg-opacity-50 h-auto">
          <div class="flex justify-center mb-4 mt-12" style="max-height: 10rem">
            <img src="../../assets/img/MOH_logo.png" style="max-height: 7rem"/>
          </div>
          <div class="self-center justify-center text-center">
            <div class="text--primary font-weight-medium">
              ወደ HRD እንኳን በደህና መጡ!
            </div>
            <div class="text--primary font-weight-medium">Welcome to HRD!</div>
          </div>
        </div>
        <div v-if="!showForgotForm" class="w-full md:w-1/4 bg-gray-500">
          <div class="form">
            <div class="self-center justify-center text-center">
              <p class="font-serif text-lg text-white-800 text-center py-2">
                Login
              </p>
            </div>
            <form>
              <div class="mb-4">
                <label class="block text-white-700 text-sm font-bold mb-2"
                >Username</label
                >
                <validation-provider v-slot="{ errors }" rules="required">
                  <input
                      v-model.trim="username"
                      class="
                    w-full
                    shadow
                    appearance-none
                    border
                    rounded
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline"
                      placeholder="username"
                      style="background: whitesmoke"
                      type="text"
                  />
                  <span class="text-gray-600 text-xs italic text-red-700">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>
              <div class="mb-6">
                <label class="block text-white-700 text-sm font-bold mb-2"
                >Password</label
                >
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="input-icons">
                    <input
                        v-if="showPassword"
                        v-model.trim="password"
                        class="
                      input-field
                      shadow
                      appearance-none
                      border
                      rounded
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="text"
                    />
                    <input
                        v-else
                        v-model.trim="password"
                        class="
                      input-field
                      shadow
                      appearance-none
                      border
                      rounded
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline"
                        placeholder="******************"
                        style="background: whitesmoke"
                        type="password"
                    />
                    <a class="button" @click="toggleShow()">
                      <v-icon v-if="showPassword">
                        mdi-eye-off
                      </v-icon>
                      <v-icon v-else>
                        mdi-eye
                      </v-icon>
                    </a>
                  </div>
                  <span class="text-gray-600 text-xs italic text-red-700">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>

              <div class="flex items-center justify-between mb-1">
                <v-btn
                    :loading="loading"
                    class="bg-gray-200 hover:bg-blue-700 text-black font-light py-2 px-4 rounded focus:outline-none focus:shadow-outline login-button"
                    style="width: 100%"
                    type="button"
                    @click="submit"
                >Sign In
                  <v-icon style="font-size: 10px"
                  >mdi-arrow-right
                  </v-icon
                  >
                </v-btn
                >
              </div>
              <div class="mb-4 pb-6">
                <a class="forgot-link" @click="forgotPassword()"
                >Forgot Password?</a
                >
              </div>
              <div class="flex-right items-center justify-between">
                <v-snackbar v-model="snackbar" absolute app>
                  <div v-for="(error, idx) in errors" :key="idx">
                    <p class="block text-white-700 text-sm font-bold mb-2">
                      {{ error.message }}
                    </p>
                  </div>
                  <template v-slot:action="{ attrs }">
                    <v-btn
                        color="pink"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                    >
                      Close
                    </v-btn>
                  </template>
                </v-snackbar>
              </div>
            </form>
          </div>
        </div>
        <div v-else class="w-full md:w-1/4 bg-gray-500">
          <div class="form">
            <div class="self-center justify-center text-center">
              <p class="font-serif text-lg text-white-800 text-center py-2">
                Reset Password
              </p>
            </div>
            <form>
              <div class="mb-6">
                <label class="block text-white-700 text-sm font-bold mb-2"
                >Email</label
                >
                <validation-provider v-slot="{ errors }" rules="required|email">
                  <input
                      v-model.trim="forgotParam.email"
                      class="border rounded-lg px-3 py-2 mt-1 mb-2 text-sm w-full text-black"
                      placeholder="email"
                      style="background: whitesmoke"
                      type="email"
                  />
                  <span class="text-gray-600 text-xs italic text-red-700">{{
                      errors[0]
                    }}</span>
                </validation-provider>
              </div>

              <div class="flex items-center justify-between mb-1">
                <v-btn
                    :loading="loading"
                    class="bg-gray-200 hover:bg-blue-700 text-black font-light py-2 px-4 rounded focus:outline-none focus:shadow-outline login-button"
                    style="width: 100%"
                    type="button"
                    @click="sendEmail()"
                >Send
                  <v-icon style="font-size: 14px">mdi-email</v-icon>
                </v-btn
                >
              </div>
              <div class="mb-4 pb-6">
                <a class="forgot-link" @click="backToLogin()">Back to login</a>
              </div>

              <!-- <div class="flex items-center justify-right mb-6">
              </div> -->
              <div class="flex-right items-center justify-between">
                <v-snackbar v-model="snackbar" absolute app>
                  <div v-for="(error, idx) in errors" :key="idx">
                    <p class="block text-white-700 text-sm font-bold mb-2">
                      {{ error.message }}
                    </p>
                  </div>
                  <template v-slot:action="{ attrs }">
                    <v-btn
                        color="pink"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                    >
                      Close
                    </v-btn>
                  </template>
                </v-snackbar>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Validation-Observer>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {email, required} from "vee-validate/dist/rules";
import {LOGIN} from "@/store/actions.type";
import {LoginService} from "./login.service";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      snackbar: false,
      showForgotForm: false,
      forgotParam: {
        email: null,
      },
      showPassword: false,
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    forgotPassword() {
      this.showForgotForm = true;
    },
    async backToLogin() {
      this.showForgotForm = false;
    },
    async sendEmail() {
      this.loading = true;
      if (!(await this.$refs.observer.validate())) {
        this.loading = false;
        return;
      }
      this.$refs.observer.validate();
      const res = await LoginService.forgotCreate(this.forgotParam);
      if (res.status === 200) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.showForgotForm = false;
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      } else {
        this.$toast.error("Unable to reset password, please try again");
      }
      this.loading = false;
    },
    async submit() {
      this.loading = true;
      if (!(await this.$refs.observer.validate())) {
        this.loading = false;
        return;
      }
      this.$refs.observer.validate();
      const loggedInUserInfo = await this.$store.dispatch(LOGIN, {
        username: this.username,
        password: this.password,
      });

      const userInfoFiltered = loggedInUserInfo["permissions"].find(permission => {
        return permission.canRead == true;
      })
      const defaultURL = '/' + userInfoFiltered.menuItem.url;
      this.$router.push(defaultURL);
    },
  },
  computed: {
    errors() {
      return this.$store.getters.hasError;
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    errors: function (value) {
      if (value.length > 0) {
        this.loading = false;
        this.snackbar = true;
      } else {
        this.snackbar = false;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #e2e2e5;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.form {
  background-color: #34495e;
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px #666;
  color: #ecf0f1;
  padding: 35px;
}

.vsnack {
  align-items: center;
  display: flex;
  min-height: 48px;
  justify-content: space-between;
  overflow: hidden;
  padding: 8px 16px;
  width: 100%;
}

.forgot-link {
  font-size: 13px;
  color: whitesmoke;
  text-decoration: underline;
  font-style: italic;
  float: right;
}

.login-button {
  background-color: #0e74b8 !important;
  color: whitesmoke;
  font-weight: 400;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  border-radius: 4px !important;
  background-color: whitesmoke;
}

/* .input-icons i {
  position: absolute;
} */
.button {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 82%;
  padding: 10px;
}
</style>
